export default "__VITE_PUBLIC_ASSET__901b7304__"